import { DashboardFilterType } from '../../../../general/types/dashboard-filter.type';
import { Granularity } from '../../../../general/shared/services/appsettings/granularity.enum';
import { TimeframePresets } from '../../../../general/enums/timeframe.presets';
import {
	SHIFT_END_18_MS,
	SHIFT_START_8_MS,
	WORKING_DAYS,
} from '../../../../general/constants/date-filter.const';

export const getDefaultDashboardFilter = (): DashboardFilterType => {
	const today = new Date();
	const priorDate = new Date().setDate(today.getDate() - 7);

	return {
		endDate: today.getTime(),
		excludeDates: [],
		granularity: Granularity.hh,
		shiftDays: WORKING_DAYS,
		shiftEnd: SHIFT_END_18_MS,
		shiftOn: false,
		shiftStart: SHIFT_START_8_MS,
		startDate: new Date(priorDate).getTime(),
		timeEnd: undefined,
		timeStart: undefined,
		vehicles: [],
		timeframe: TimeframePresets.Last7Days,
	};
};
